<template>
  <span class="time">
    {{hours}}<span class="time__delimiter">:</span>{{minutes}}&nbsp;{{date}}
  </span>
</template>

<script>
  export default {
    name: 'timer',
    data () {
      return {
        intervalId: null,
        hours: null,
        minutes: null,
        date: null
      }
    },
    methods: {
      setTime () {
        const now = new Date()
        this.hours = now.getHours()
        this.minutes = now.getMinutes() <= 9 ? '0' + now.getMinutes() : now.getMinutes()
        this.date = this.formatDate(now)
      },
      padTo2Digits (num) {
        return num.toString().padStart(2, '0')
      },
      formatDate (date) {
        return [
          this.padTo2Digits(date.getDate()),
          this.padTo2Digits(date.getMonth() + 1),
          date.getFullYear().toString().slice(-2)
        ].join('.')
      }
    },
    mounted () {
      this.setTime()
      this.intervalId = setInterval(() => {
        this.setTime()
      }, 1000)
    },
    beforeDestroy () {
      clearInterval(this.intervalId)
    }
  }
</script>
